<template>
  <div class="home-map">
    <reallMap
    v-bind="$attrs" 
    v-on="$listeners"  
    :dataList="list" 
    :lineList="lineList" 
    :coord="coord"
    :showLine="showLine"></reallMap>
    <!-- <PicMap 
      v-bind="$attrs" 
      v-on="$listeners"  
      :marksList="list" 
      :lineList="lineList" 
      :showLine="showLine"></PicMap> -->
    
  </div>
</template>
<script>
import reallMap from "@/components/m-map/MapHomeSmall.vue"
// import PicMap from "@/components/picMap/index.vue"
import mapApi from "@/api/map"
import { mapState, mapActions } from "vuex"
import config from "@/config"
export default {
  components:{reallMap},
  props:{
    coordType:[Number,String],
    curId:[Number,String],
    showLine:Boolean
  },
  data(){
    return{
      config,
      list:[],
      lineList:[],
      coord:[],//是否定位
    }
  },
  computed:{
    // ...mapState(['allType'])
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(['getAllType']),
    init(){
      this.getList()
      // this.checkAim()
    },
    getList(){
      let curMap =  config.site.find(t=>{return t.spot == parseInt(this.$route.query.spot)})
      let params={
        // typeid:this.coordType || -1 ,//点坐标类型
        typeid:curMap.spot
      }
      mapApi.getSpotList(params).then(res=>{
        let list = res.data
        list.map((t,index)=>{
          if(t.id == this.curId){
            t.checked = true;
          }
          if(t.coordinate){
            t.coordinate =Array.isArray(t.coordinate) ?t.coordinate: t.coordinate.split(",")
          }
        })
        this.list = list

        // setTimeout(() => {
        //   this.getRouteList()
        // }, 1000);
      })
    },

    //获取路线
    async getRouteList(){
      if(this.lineList && this.lineList.length) return
      let data = await this.$api.mapApi.getRouteList();
      let list = data.data;
      let lineArr = [];
      list.forEach(t => {
        if(t.coordinate){
            t.coordinate =Array.isArray(t.coordinate) ?t.coordinate: t.coordinate.split(",")
          }
        // item.coordinate = this.$utils.map.formatlat(item.coordinate);
        lineArr.push(t.coordinate);
      });
      this.lineList = lineArr;
    },

    //判断是否在景区 --地图内的效果
    async checkAim(){
      let newslocation = await this.toAim('location');
      if(newslocation=='location'){//为location 在景区时自动定位
         setintervalTime = setInterval(() => {
          that.toAim();
         }, 5000);
      }
    },

    toAim(){
      return new Promise((resolve,reject)=>{
        let longitude = [110.14868070099638,110.15308090546965]
        let latitude = [27.341524786075484,27.349780812305705]
        this.$api.mapApi.getCoordinate().then(res=>{
          // console.log(res);
          if(res && res.data){
            let curCoordinate = res.data.latitude
            if(curCoordinate){
              curCoordinate = curCoordinate.split(",")
              let xt = [parseFloat(curCoordinate[0]),parseFloat(curCoordinate[1])];
              xt.sort((a,b)=>{
                return b-a
              })
              let coord = xt
              if(xt[1]>= latitude[0] && 
              xt[1] <= latitude[1] && 
              xt[0] >=longitude[0] && 
              xt[0]<=longitude[1] ){
                coord = xt
                if(type=='location'){
                  resolve('location');
                }
              }else{
                !type&&(this.$toast.fail("您不在景区范围内"));
                coord = [];
                resolve('no');
              }
              if(coord.length>0&&type=='init'){
                coord.push('init');
              }
              this.coord = coord;
            }
          }else{
          // if(!this.showVr&&!this.showVideo){
          this.$toast.fail("请在手机端打开或允许定位权限")
          // }
            resolve('no');
          }
        })
          
      })
    }


    

  },
  watch:{
    coordType:{
      handler(newv,oldv){
        this.$nextTick(()=>{
          this.init()
        })
      },immediate:true,deep:true
    },
  }
}
</script>
<style lang="scss" scoped>
.home-map{
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
</style>